type Props = {
  title: string;
  description: string;
  next?: string;
};

export function PlaceholderPage({ title, description, next }: Props) {
  return (
    <section className="stack">
      <div><h1>{title}</h1><p className="muted">{description}</p></div>
      {next ? <div className="help-tip">Tahap implementasi berikutnya: {next}</div> : null}
    </section>
  );
}
